<template>
  <div class="header">
    <div class="header-name">
      <div>{{ i18nCompetitionName }}</div>
      <div class="register-time">
        <i class="el-icon-time time-icon " ></i>
        {{ $t('header.registerTime') }}: {{ competitionInfo.fakeStartTime }} - {{ competitionInfo.fakeEndTime }}
      </div>
    </div>
    <div class="header-logo">
      <div class="logo-img" v-if="competitionInfo.logo1"><img :src="define.previewNginxUrl + competitionInfo.logo1"/></div>
      <div class="logo-img" v-if="competitionInfo.logo2"><img :src="define.previewNginxUrl + competitionInfo.logo2"/></div>
      <div class="logo-img" v-if="competitionInfo.logo3"><img :src="define.previewNginxUrl + competitionInfo.logo3"/></div>
      <div class="header-team">
        <div class="team-info">
          <div class="team-header">
            <div class="team-name">{{teamName}}</div>
            <i class="el-icon-user team-icon"></i>
            <div class="username" v-if="username">{{username}}</div>
          </div>
          <div class = "header-button" v-if="showLogout">
            <!-- 语言切换器 -->
            <LangSwitcher v-if="showLogout" />
            <div><el-button type="text" @click="logout()"><i class="el-icon-switch-button switch-button " />{{ $t('header.logout') }}</el-button></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LangSwitcher from '@/components/LangSwitcher.vue'
export default {
  components: { LangSwitcher },
  props: {
    competitionInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    teamName: {
      type: String,
      default: ''
    },
    username: {
      type: String,
      default: ''
    },
    showLogout: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    // 赛事名称中英文
    i18nCompetitionName() {
      return this.$i18n.locale === 'zh-CN' ? this.competitionInfo.nameCh : (this.competitionInfo.nameEn || this.competitionInfo.nameCh);
    },
  },
  methods: {
    logout() {
      this.$emit('logout');
    },
  }
}

</script>
<style scoped lang="scss">
.header {
  width: 100%;
  height: 120px;
  background-color: #001c58;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .header-name{
    font-size: 30px;
    color: #FFFFFF;
    font-weight: 600;
    margin-left: 30px;
    line-height: 36px;
    letter-spacing: 2px;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);

    div:first-child {
      position: relative;
      padding-left: 14px;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        height: 24px;
        background: #409EFF;
        border-radius: 2px;
      }
    }
  }
  .register-time {
    font-size: 18px;
    background: #83b9f7;
    display: inline-flex;
    align-items: center;
    padding: 6px 18px;
    border-radius: 30px;
    font-weight: bold;
    margin-top: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);

    .time-icon {
      color: #fff;
      margin-right: 8px;
      font-size: 18px;
    }
  }

  .header-logo {
    display: flex;

    .logo-img{
      margin: 0 10px;

      img {
        border-radius: 50%;
        width: 100px;
        height: 100px;
      }
    }

    .header-team {
      text-align: right;
      margin-right: 30px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .team-info {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
      }

      .team-header {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
      }

      .team-name {
        color: #FFFFFF!important;
        font-size: 16px;
        margin-bottom: 0;
      }

      .username {
        color: rgba(255, 255, 255, 0.75);
        font-size: 14px;
        margin-left: 16px;

        &::before {
          content: '|';
          margin-right: 16px;
          color: rgba(255, 255, 255, 0.3);
        }
      }

      .team-icon {
        color: #FFFFFF!important;
        font-size: 20px;
        margin-left: 8px;
      }
    }
    .header-button {
      margin-top: 10px;
      color: #FFFFFF;
      display: flex;
      align-items: center;
      gap: 10px;

      .switch-button {
        margin-right: 8px;
        color: #FFFFFF !important;
      }

      .el-button {
        color: #FFFFFF !important;
      }

      .el-button span {
        color: #FFFFFF !important;
      }
    }
  }
}
</style>
